import { Rule } from "../models/Rule";


export class RuleSearchResult {
    constructor(
        public ruleId: string,
        public rule: Rule,
        public path: Array<number>,
        public topLevelParent: Rule | undefined,
        public parent?: Rule
    ) { }
}

export class DataCleaningSearchService {

    public static findRuleByIdRecursive(
        rules: Rule[],
        targetId: string
    ): RuleSearchResult | null {
        return this.search(rules, targetId);
    }

    private static search(rules: Rule[],
        targetId: string,
        parent?: Rule,
        topLevelParent?: Rule,
        path: number[] = []
    ): RuleSearchResult | null {
        for (let i = 0; i < rules.length; i++) {
            const rule = rules[i];
            const currentPath = [...path, i];
            const currentTopLevel = topLevelParent ?? rule;

            if (rule.id === targetId) {
                return new RuleSearchResult(targetId, rule, currentPath, currentTopLevel, parent);
            }

            const nestedRules = rule.configuration?.rules;
            if (Array.isArray(nestedRules)) {
                const result = this.search(nestedRules, targetId, rule, currentTopLevel, currentPath);
                if (result) return result;
            }
        }

        return null;
    }

    public static setRuleAtPath(
        topLevelParent: Rule,
        path: number[],
        newRule: Rule
    ): boolean {
        if (path.length === 0) return false; // Nothing to replace

        let currentRules = topLevelParent.configuration?.rules
        if (!Array.isArray(currentRules)) return false;

        // Traverse to the parent of the target rule
        for (let i = 0; i < path.length - 1; i++) {
            const index = path[i];
            const rule = currentRules[index];
            if (!rule?.configuration?.rules) return false;

            currentRules = rule.configuration.rules;
        }

        const targetIndex = path[path.length - 1]

        // Replace the target rule
        if (currentRules && currentRules[targetIndex]) {
            currentRules.splice(targetIndex, 1, newRule)
            return true;
        }

        return false;
    }

}